<script setup lang="ts">
import { ref } from "vue";
import Container from "../Container.vue";
import SVGMaskNapkin from "../svg/SVGMaskNapkin.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Container, SVGMaskNapkin },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    maskMode?: "alaph" | "luminance" | "match-source"; // 使用「不透明度」或「亮度值」作为 mask value, 数值越大越暴露
    imageUrl?: string;
  }>(),
  {
    maskMode: "alaph",
    // imageUrl: "https://github.githubassets.com/pinned-octocat.svg"
    imageUrl: ""
  }
);

const width = ref(0);
const height = ref(0);
const resize = (controller) => {
  width.value = controller.rect.width;
  height.value = controller.rect.height;
};

// mask-composite: add; /* 叠加（默认） */
// mask-composite: subtract; /* 减去，排除掉上层的区域 */
// mask-composite: intersect; /* 相交，只显示重合的地方 */
// mask-composite: exclude; /* 排除，只显示不重合的地方 */

defineExpose({});
</script>

<template>
  <div
    :style="{
      width: `${width}px`,
      height: `${height}px`,
      maskImage: props.imageUrl ? `url(${props.imageUrl})` : `url(#mask)`,
      'mask-mode': props.maskMode
    }"
  >
    <!-- slot 必须包含 #mask 元素 -->
    <slot name="mask"><SVGMaskNapkin></SVGMaskNapkin></slot>
    <Container
      type="shrink"
      @ready="resize"
      @update="resize"
    >
      <slot></slot>
    </Container>
  </div>
</template>
